import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    class: "card",
    "data-testid": "card"
};
const _hoisted_2 = { class: "flex justify-content-between align-items-center mb-3" };
const _hoisted_3 = { class: "headline" };
const _hoisted_4 = { class: "flex" };
const _hoisted_5 = {
    key: 0,
    class: "mr-3"
};
const _hoisted_6 = { class: "p-input-icon-left p-input-icon-right" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-search" }, null, -1);
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "p-buttonset" };
const _hoisted_10 = { key: 2 };
const _hoisted_11 = {
    key: 0,
    "data-testid": "display-filters-component",
    class: "mb-3"
};
const _hoisted_12 = { class: "flex gap-2 align-items-center" };
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import Menu from "primevue/menu";
import InputText from "primevue/inputtext";
import { computed, ref } from "vue";
import Button from "primevue/button";
import { useStore } from "@/shared/composables/useStore";
import { AllActionTypes } from "@/store/action-types";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskCard',
    props: {
        title: {},
        searchText: {},
        hasSearch: { type: Boolean, default: false },
        hasFilters: { type: Boolean, default: true },
        hasMenu: { type: Boolean, default: false },
        menuItems: {},
        displayFiltersFromOutside: { type: Boolean }
    },
    emits: ['update:searchText', 'clear-filters'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const store = useStore();
        const displayFilters = computed(() => store.getters.getDisplayFilters);
        const searchTextProxy = ref(props.searchText ?? "");
        const menu = ref();
        const updateDisplayFilters = (display) => {
            store.dispatch(AllActionTypes.SET_DISPLAY_FILTERS, display);
        };
        const toggleFilters = () => {
            updateDisplayFilters(!displayFilters.value);
        };
        const clearFilters = () => {
            searchTextProxy.value = "";
            emit('clear-filters');
        };
        const clearAndEmitSearchText = () => {
            searchTextProxy.value = "";
            emit('update:searchText', searchTextProxy.value);
        };
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                        (_ctx.hasSearch)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, [
                                    _hoisted_7,
                                    _createVNode(_unref(InputText), {
                                        modelValue: searchTextProxy.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTextProxy).value = $event)),
                                        type: "text",
                                        placeholder: "Search",
                                        onChange: _cache[1] || (_cache[1] = ($event) => (emit('update:searchText', $event.target.value)))
                                    }, null, 8, ["modelValue"]),
                                    _createElementVNode("i", {
                                        class: "pi pi-times",
                                        onClick: clearAndEmitSearchText
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.hasFilters)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, [
                                    _createVNode(OneDeskButton, {
                                        icon: displayFilters.value ? 'pi pi-filter-slash' : 'pi pi-filter',
                                        label: displayFilters.value ? 'Hide filters' : 'Display filters',
                                        class: "p-button-outlined mb-2",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (toggleFilters()))
                                    }, null, 8, ["icon", "label"]),
                                    _createVNode(OneDeskButton, {
                                        severity: "warning",
                                        icon: "pi pi-times-circle",
                                        label: "Clear filters",
                                        class: "p-button-outlined mb-2",
                                        onClick: clearFilters
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.hasMenu)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_unref(Button), {
                                    icon: "pi pi-ellipsis-v",
                                    class: "p-button-text p-button-plain p-button-rounded",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (menu.value.toggle($event)))
                                }),
                                _createVNode(_unref(Menu), {
                                    ref_key: "menu",
                                    ref: menu,
                                    popup: true,
                                    model: _ctx.menuItems
                                }, null, 8, ["model"])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (displayFilters.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _renderSlot(_ctx.$slots, "filters")
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "content")
                ])
            ]));
        };
    }
});
